import { useMemo } from 'react'

import { DoughnutChart } from '@/components/charts/doughnut-chart'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { getPercentValue } from '@/utils/helpers.ts'

import { SpendingPieChart } from '../../../types'

interface SpendingFansChartProps {
  spendingPieChart: SpendingPieChart
}

export const SpendingFansChart = ({
  spendingPieChart,
}: SpendingFansChartProps) => {
  const spendingRate = useMemo(
    () =>
      getPercentValue(
        (spendingPieChart?.spenders ?? 0) /
          ((spendingPieChart?.spenders ?? 0) + spendingPieChart?.nonSpenders),
      ),
    [spendingPieChart],
  )

  return (
    <Card>
      <CardHeader>
        <CardTitle>Spending Fans</CardTitle>
        <CardDescription>{spendingRate} Spending Fans</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="mx-auto h-full max-h-[200px] w-full max-w-[200px]">
          <DoughnutChart
            data={{
              labels: ['Spending Fans', 'Rest'],
              datasets: [
                {
                  data: [
                    spendingPieChart.spenders,
                    spendingPieChart.nonSpenders,
                  ],
                  backgroundColor: ['#E8157B', '#F4F5F9'],
                },
              ],
            }}
            options={{
              plugins: {
                legend: {
                  display: false,
                },
              },
            }}
            toggleOptions={{
              hideLegend: true,
            }}
          />
        </div>
        <div className="mt-12 flex flex-col gap-4">
          <div className="flex items-center justify-between text-lg font-medium text-secondary-500 dark:text-white">
            <h5>Total Claimed Fans</h5>
            <h5>
              {(spendingPieChart.nonSpenders ?? 0) +
                (spendingPieChart.spenders ?? 0)}
            </h5>
          </div>
          <div className="flex items-center justify-between font-medium leading-4 text-secondary-500 dark:text-white">
            <h5 className="flex items-center gap-2">
              <div className="h-3 w-3 rounded-full bg-[#E8157B]" />
              Spending Fans
            </h5>
            <h5>{spendingPieChart.spenders}</h5>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
